import {
  put,
  call,
  take,
  every,
  takeLatest,
  takeEvery,
} from "redux-saga/effects";
import * as CONST from "./actionTypes";
import * as ACTION from "./actions";
import * as API from "../../Services/ApiCalls";
import { toast } from "react-toastify";

function* templatesListSaga({ payload, callBack }) {
  try {
    const response = yield call(API.TEMPLATES_LIST, payload);
    if (response.status == 200) {
      yield put(ACTION.templatesList_Success(response.data));
    } else {
      yield put(ACTION.templatesList_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.templatesList_Fail(response.data.error));
  }
}
function* EditTemplatessaga({ payload, callBack }) {
  try {
    const response = yield call(API.EDIT_MANAGE_TEMPLATES, payload);
    if (response.status == 200) {
      yield put(ACTION.editTemplates_Success(response.data));
    } else {
      yield put(ACTION.editTemplates_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.editTemplates_Fail(response.data.error));
  }
}
function* updateTemplatesSaga({ payload, callBack }) {
  try {
    const response = yield call(API.UPDATE_TEMPLATES, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.updateTemplates_Success(response.data));
    } else {
      toast.error(response.data.error);
      yield put(ACTION.updateTemplates_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.updateTemplates_Fail(response.data.error));
  }
}
function* addTemplatesSaga({ payload, callBack }) {
  try {
    const response = yield call(API.ADD_TEMPLATES, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.addTemplates_Success(response.data));
    } else {
      toast.error(response.data.error);
      yield put(ACTION.addTemplates_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.addTemplates_Fail(response.data.error));
  }
}

function* deleteTemplatesSaga({ payload, callBack }) {
  try {
    const response = yield call(API.DELETE_TEMPLATES, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.deleteTemplates_Success(response.data));
    } else {
      toast.error(response.data.detail);
      yield put(ACTION.deleteTemplates_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.deleteTemplates_Fail(response.data.error));
  }
}

function* TemplatesSaga() {
  yield takeEvery(CONST.TEMPLATES_LIST, templatesListSaga);
  yield takeEvery(CONST.EDIT_TEMPLATES, EditTemplatessaga);
  yield takeEvery(CONST.UPDATE_TEMPLATES, updateTemplatesSaga);
  yield takeEvery(CONST.ADD_TEMPLATES, addTemplatesSaga);
  yield takeEvery(CONST.DELETE_TEMPLATES, deleteTemplatesSaga);
}

export default TemplatesSaga;
